export const showUpcomingThreshold = 604800000; // 1 week in ms

// todo - move to appropriate location
export const bestOfToWinThreshold = (bestOf: number) => {
  return Math.ceil((bestOf + 1) / 2);
};

// todo - move to approriate location
export const JoinTypeOpen = "Open";
export const JoinTypeRequest = "Request";
export const JoinTypeClosed = "Closed";
export const MIN_GROUP_NAME_LENGTH = 1;
export const MAX_GROUP_NAME_LENGTH = 25;
